import Base from '../base/Base';

export default class RemovableFileInfo extends Base {
  name: string = '';
  path: string = '';
  isDir: boolean = false;
  size: number = 0;
  modifiedTime: string = '';
  mode: string = '';
  extension: string = '';

  // 格式化文件大小
  getFormattedSize(): string {
    if (this.isDir) return '--';
    return this.formatSize(this.size);
  }

  // 格式化修改时间
  getFormattedModifiedTime(): string {
    return new Date(this.modifiedTime).toLocaleString();
  }

  // 获取文件类型图标
  getFileTypeIcon(): string {
    if (this.isDir) return 'folder';
    
    const extension = this.extension.toLowerCase();
    if (['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp'].includes(extension)) {
      return 'file-image';
    } else if (['.pdf'].includes(extension)) {
      return 'file-pdf';
    } else if (['.doc', '.docx'].includes(extension)) {
      return 'file-word';
    } else if (['.xls', '.xlsx'].includes(extension)) {
      return 'file-excel';
    } else if (['.ppt', '.pptx'].includes(extension)) {
      return 'file-ppt';
    } else if (['.txt', '.md', '.json', '.xml', '.html', '.css', '.js'].includes(extension)) {
      return 'file-text';
    } else if (['.zip', '.rar', '.7z', '.tar', '.gz'].includes(extension)) {
      return 'file-zip';
    } else if (['.mp3', '.wav', '.flac', '.aac'].includes(extension)) {
      return 'file-audio';
    } else if (['.mp4', '.avi', '.mov', '.mkv', '.flv'].includes(extension)) {
      return 'file-video';
    }
    
    return 'file';
  }

  // 判断文件是否可预览
  canPreview(): boolean {
    if (this.isDir) return false;
    
    const extension = this.extension.toLowerCase();
    const previewableExtensions = [
      '.txt', '.md', '.json', '.xml', '.html', '.css', '.js',
      '.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp',
      '.pdf'
    ];
    
    return previewableExtensions.includes(extension);
  }

  // 获取预览类型
  getPreviewType(): string {
    const extension = this.extension.toLowerCase();
    if (['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp'].includes(extension)) {
      return 'image';
    } else if (['.pdf'].includes(extension)) {
      return 'pdf';
    } else if (['.txt', '.md', '.json', '.xml', '.html', '.css', '.js'].includes(extension)) {
      return 'text';
    }
    return 'unknown';
  }

  private formatSize(bytes: number): string {
    const units = ['B', 'KB', 'MB', 'GB', 'TB'];
    let size = bytes;
    let unitIndex = 0;
    
    while (size >= 1024 && unitIndex < units.length - 1) {
      size /= 1024;
      unitIndex++;
    }
    
    return `${size.toFixed(1)} ${units[unitIndex]}`;
  }
}